<template>
  <v-window v-model="manageTabIndex" :mandatory="false" :touch="false">
    <!-- TAB PROJECTS -->
    <v-window-item :transition="false" :reverse-transition="false" value="projects-projects">
      <manage-projects-list></manage-projects-list>
    </v-window-item>

    <!-- TAB OPEN PROJECTS-->
    <v-window-item v-for="project in openedProjects" :key="project.id" :transition="false" :reverse-transition="false"
                   :value="`projects-project${project.id}`">
      <manage-projects-project-acr ref="projectTabs" :project="project"></manage-projects-project-acr>
    </v-window-item>
  </v-window>
</template>

<script>
  import { mapState } from 'pinia';
  import useEventbusStore from '@/stores/eventbus';
  import useManageStore from '@/stores/manage';
  import ManageProjectsList from './ManageProjectsList.vue';
  import ManageProjectsProjectAcr from './ManageProjectsProjectAcr.vue';

  export default {
    components: {
      ManageProjectsList,
      ManageProjectsProjectAcr,
    },
    data() {
      return {
        eventbusStore: useEventbusStore(),
        manageStore: useManageStore(),
      };
    },
    computed: {
      manageTabIndex: {
        get() {
          return this.manageStore.manageTabIndex;
        },
        set(newVal) {
          this.manageStore.manageTabIndex = newVal;
        },
      },
      ...mapState(useManageStore, ['dataLoaded', 'projects', 'openedProjects']),
    },
    created() {
      this.eventbusStore.register({
        event: 'update-project-tabs',
        listener: 'manage-projects',
        cb: (projectInfo) => {
          this.onUpdateUserRightsInProject(projectInfo);
        },
      });
    },
    methods: {
      onUpdateUserRightsInProject({ userId, projectId, data }) {
        const projectIndex = this.openedProjects.findIndex(item => item.id == projectId);
        if (projectIndex == -1) return;
        const projectTab = this.$refs.projectTabs[projectIndex];
        if (projectTab.onUpdateUserRightsInProject) projectTab.onUpdateUserRightsInProject({ userId, projectId, data });
      },
    },
  };
</script>
